var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "166",
      "height": "162"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFE86C",
      "d": "M.535 78.125C.535 34.978 35.513 0 78.66 0c43.148 0 78.125 34.978 78.125 78.125S121.808 156.25 78.66 156.25C35.513 156.25.535 121.272.535 78.125"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFE86C",
      "stroke": "#FFF",
      "stroke-width": "3",
      "d": "M138.121 108.561c14.187 0 25.689 11.501 25.689 25.688s-11.502 25.688-25.689 25.688-25.688-11.5-25.688-25.688 11.501-25.688 25.688-25.688Z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "m145.635 143.707-18.001-18.002 2.681-2.681 18.002 18.001z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "m148.318 125.71-18.001 18.002-2.682-2.682 18.002-18.001z"
    }
  }), _c('path', {
    attrs: {
      "d": "M35 134V42h92v92z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M77.193 72.77v-7.615h7.614v7.615zm7.614 30.46h-7.614V80.385h7.614zM81 53.733c-19.228 0-33.696 7.044-45.69 16.105L81 126.075l45.69-56.16C114.696 60.853 100.228 53.733 81 53.733"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }